import NAME from "./constants";

export const getDelegationsRows = store => store[NAME].delegationsRows;
export const getManagersEmployers = store => store[NAME].managersEmployers;
export const getLoading = store => store[NAME].loadingSet || store[NAME].loadingRows || store[NAME].loadingDelete || store[NAME].loadingManagersEmployees;
export const getAllEmployees = store => store[NAME].allEmployees;